import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LOGIN_PATH } from '../../utils/Constants'

function LandingPage() {
    const navigate = useNavigate()
    const navigateToLogin = () => {
        navigate(LOGIN_PATH)
    }

    useEffect(() => {
        navigateToLogin()
    }, [])
    return (
        <></>
    )
}

export default LandingPage